module.exports = __webpack_public_path__ + "img/award-05.904fc093.svg";